import React, { useState, useEffect } from 'react';
import HomeWeb from './components/HomeWeb';
import WhyNexusLiving from './components/WhyNexusLiving';
import ContactUs from './components/ContactUs';
import './App.css';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      if (hash === '#why-nexus') {
        setCurrentPage('why-nexus');
      } else if (hash === '#contact') {
        setCurrentPage('contact');
      } else {
        setCurrentPage('home');
      }
    };

    // 初始检查
    handleHashChange();

    // 监听hash变化
    window.addEventListener('hashchange', handleHashChange);
    
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  const renderPage = () => {
    switch (currentPage) {
      case 'why-nexus':
        return <WhyNexusLiving />;
      case 'contact':
        return <ContactUs />;
      default:
        return <HomeWeb />;
    }
  };

  return (
    <div className="App">
      {renderPage()}
    </div>
  );
}

export default App;
